import { reskinStyles } from 'core/components/theme/theme-variant';
import { makeStyles } from '@material-ui/core/styles';

const styles = (theme) => ({
  link: {
    color: theme.colors.action_text,
    cursor: 'pointer',
    ...reskinStyles(theme, theme.actionStyles.link)
  }
});

export default makeStyles(styles);
